(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repairs-contact-form"] && !Shopify.designMode) return;
  try {
    
  

  
 // Get references to the elements
const brandDropdown = document.getElementById("brandDropdown");
const categoryDropdown = document.getElementById("categoryDropdown");
const modelDropdown = document.getElementById("modelDropdown");
const checkboxList = document.getElementById("checkboxList");
const totalPriceText = document.getElementById("totalPrice");

// Define options for the second dropdown (category) based on the selected brand
const categoryByBrand = {
  "Apple": ["iPhone", "iPad", "iPad Air", "iPad Pro", "iPad Mini", "Apple Watch"],
  "Samsung": ["S series", "Note Series", "A Series", "J Series", "Z Series", "Galaxy Tablet"],
  "Google": ["Pixel Series", "Nexus Series"],
  "Oppo": ["A series", "Reno Series", "R Series", "Find Series"],
  "Realme": ["7 series", "6 Series", "3 Series", "2 Series", "C Series"],
  "OnePlus": ["S series", "Note Series", "A Series", "J Series", "Z Series", "Galaxy Tablet"],
  "Huawei": ["Mate series", "P Series", "Y Series", "Nova Series", "Honor Series", "G Series"],

  // Add more brands and models as needed
};

// Define options for the third dropdown (models) based on the selected category
const modelsByCategories = {

  // "Apple Watch Ultra", "Apple Watch Series 8", "Apple Watch SE", "Apple Watch Series 7", "Apple Watch Series 6", "Apple Watch SE", "Apple Watch Series 5", "Apple Watch Series 4", "Apple Watch Series 3", "Apple Watch Series 2", "Apple Watch Series 1", "Apple Watch (1st generation)"],
  // "iPad (10th generation)", "iPad (9th generation)", "iPad (8th generation)", "iPad (7th generation)", "iPad (6th generation)", "iPad (5th generation)", "iPad (4 generation)", "iPad Air (5th)", "iPad Air (4th)", "iPad Air (3rd)", "iPad Air (2nd)", "iPad Air (1st)", "iPad mini (6th)", "iPad mini (5th)", "iPad mini (4th)", "iPad mini (3rd)", "iPad Pro (6th)", "iPad Pro (5th)", "iPad Pro (4th)", "iPad Pro (3rd)", "iPad Pro (2nd)", "iPad Pro (1st)",],   
  // Galaxy S21 Ultra", "Galaxy S21+", "Galaxy S21", "Galaxy Z Fold 3", "Galaxy Z Flip 3", "Galaxy Note 20 Ultra", "Galaxy Note 20", "S23 Ultra", "S23 Plus", "Galaxy S23", "S22 Ultra", "S22 Plus", "Galaxy S22", "S21 Ultra", "S21 Plus", "Galaxy S21", "S20 Ultra", "S20 Plus", "Galaxy S20", "S10 Plus", "S10", "Galaxy S10e"],

  "iPhone": ["iPhone 17 Pro Max", "iPhone 17 Pro", "iPhone 17 Air", "iPhone 17","iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16","iPhone 16E","iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15", "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus",
    "iPhone 14", "iPhone 13 Mini", "iPhone SE (3rd generation)", "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13", "iPhone 12 Pro Max", "iPhone 12 Pro",
    "iPhone 12", "iPhone 12 Mini", "iPhone SE (2nd generation)", "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11", "iPhone XR", "iPhone XS Max",
    "iPhone XS", "iPhone X", " iPhone 8 plus", "iphone 8",],
  "iPad": ["iPad 10 (2022)",
    "iPad 9 (2021)",
    "iPad 7 (2019) / 8 (2020)",
    "iPad 6 (2018)",
    "iPad 5 (2017)",
    "iPad 4",
    "iPad 3",
    "iPad 2",
    "iPad 1",],
  "iPad Air": ["iPad Air",
    "iPad Air 5",
    "iPad Air 4",
    "iPad Air 3",
    "iPad Air 2",
    "iPad Air 1",],
  "iPad Pro": ["iPad Pro",
    "iPad Pro 12.9 5th",
    "iPad Pro 12.9 4th",
    "iPad Pro 12.9 3rd",
    "iPad Pro 12.9 2nd",
    "iPad Pro 12.9 1st",
    "iPad Pro 11 3rd / 4th",
    "iPad Pro 11 1st / 2nd",
    "iPad Pro 10.5",
    "iPad Pro 9.7",],
  "iPad Mini": ["iPad Mini",
    "iPad Mini 6",
    "iPad Mini 5",
    "iPad Mini 4",
    "iPad Mini 3",
    "iPad Mini 2",
    "iPad Mini 1",],
  "Apple Watch": ["Apple Watch 8 41MM",
    "Apple Watch 8 45MM",
    "Apple Watch SE2 40MM",
    "Apple Watch SE2 44MM",
    "Apple Watch 7 41MM",
    "Apple Watch 7 44MM",
    "Apple Watch SE 40MM",
    "Apple Watch SE 44MM",
    "Apple Watch 6 40MM",
    "Apple Watch 6 44MM",
    "Apple Watch 5 40MM",
    "Apple Watch 5 44MM",
    "Apple Watch 4 40mm",
    "Apple Watch 4 44mm",
    "Apple Watch 3 38mm",
    "Apple Watch 3 42mm",
    "Apple Watch 2 38mm",
    "Apple Watch 2 42mm",
    "Apple Watch 1 38mm",
    "Apple Watch 1 42mm",],


  "S series": ["S25 FE",
    "S24 Ultra",
    "S24 Plus",
    "S24",
    "S23 Ultra",
    "S23 Plus",
    "S23",
    "s23 FE",
    "S22 Ultra",
    "S22 Plus",
    "S22",
    "S21 Ultra",
    "S21 Plus",
    "S21",
    "S21 FE",
    "S20 Ultra",
    "S20 Plus",
    "S20",
    "S20 FE",
    "S10 5G",
    "S10 Plus",
    "S10",
    "S10e",
    "S9 Plus",
    "S9",
    "S8 Plus",
    "S8",],




  "Note Series": ["Note 20 Ultra",
    "Note 20",
    "Note 10 Plus 4G/5G",
    "Note 10",
    "Note 9",
    "Note 8",
    "Note 5",],


  "A Series": ["A04s A047",
    "A90 5G",
    "A8 A530",
    "A73 5G A736",
    "A72 A725",
    "A71 5G A716",
    "A71 A715",
    "A70 2019 A705",
    "A54 [5G] A546",
    "A53 [5G] A536",
    "A52s A528",
    "A52 A525 A526",
    "A51 5G A516",
    "A51 A515",
    "A50S A507",
    "A50 A505",
    "A42 A426",
    "A40 2019 A405",
    "A35 5G A356",
    "A34 [5G] A346",
    "A33 [5G] A336",
    "A32 A325 A326",
    "A31 A315",
    "A30s A307",
    "A30 2019 A305",
    "A24 4G A245",
    "A23 5G A236",
    "A23 A235",
    "A22 5G A226",
    "A22 4G A225",
    "A21s A217",
    "A20s A207",
    "A20 A205",
    "A14 [5G] A146",
    "A14 [4G] A145",
    "A13s A137",
    "A13 5G A136",
    "A13 A135",
    "A12 Nacho A127",
    "A12 A125",
    "A11 A115",
    "A10 A105",
    "A04s A047",
    "A810 A8 2016",
    "A750 A7 2018",
    "A730 A8 Plus 2018",
    "A720 A7 2017",
    "A710 A7 2016",
    "A700 A7 2015",
    "A605 A6 Plus 2018",
    "A600 A6 Plus 2018",
    "A530 A8 2018",
    "A520 A5 2017",
    "A510 A5 2016",
    "A500 A5 2015",
    "A320 A3 2017",
    "A310 A3 2016",
    "A300 A3 2015",],
  "J Series": ["J8 2018 J810",
    "J7 Prime 2016 G610",
    "J7 Pro 2017 J730",
    "J7 Duo 2016 J710",
    "J7 2015 J700",
    "J5 Prime 2016 G570",
    "J5 Pro 2017 J530",
    "J5 2016 J510",
    "J5 2015 J500",
    "J3 Pro 2017 J330",
    "J3 2016 J300 J320",
    "J2 Pro 2018 J250",
    "J1 2016 J120",
    "J1 Ace 2016 J110",
    "J1 Mini J105 J106",
    "J100",],
  "Z Series": ["Z Fold 6",
    "Z Fold 5",
    "Z Fold 4",
    "Z Fold 3",
    "Z Fold 2",
    "Z Fold",
    "Z Flip 5",
    "Z Flip 4",
    "Z Flip 3",
    "Z Flip 5G",
    "Z Flip 6",
    "Z Flip 4G",],
  "Galaxy Tablet": ["Note Pro 12.2",
    "Note 10.1",
    "Note 8.0",
    "Tab Active 4 Pro ",
    "Tab Active Pro 10.1",
    "Tab Active 3",
    "Tab Active 2",
    "Tab Active",
    "Tab Pro",
    "Tab S9 / S9 Ultra / S9 FE",
    "Tab S8 Plus X800 X808",
    "Tab S8 (X700 X706)",
    "Tab S8 Ultra",
    "Tab S7 FE",
    "Tab S7 / S7 Plus",
    "Tab S6 / S6 Lite",
    "Tab S5E",
    "Tab S4",
    "Tab S3",
    "Tab S2",
    "Tab S",
    "Tab 4",
    "Tab 3",
    "Tab 2",
    "Tab 1",
    "Tab A9 Plus",
    "Tab A8 10.5 (X200 X205)",
    "Tab A7 Lite T225",
    "Tab A7 Lite T220",
    "Tab A7 10.4",
    "Tab A 10.5",
    "Tab A 10.1",
    "Tab A 9.7",
    "Tab A 8.0 (SM-X200 SM-X205)",
    "Tab A 7.0",],
    "7 series":[
      "Realme 7 5G",
      "Realme 7",
    ], 
    "6 Series":["Realme 6",], 
    "3 Series":["Realme 3","Realme 3i",],
    "2 Series":["Realme 2","Realme 2 Pro",],
    "C Series":["Realme C1","Realme C2","Realme C3","Realme C11","Realme C12","Realme C15","Realme C21","Realme C55",],
    "Mate series":[
      "Mate 7",
      "Mate 8",
      "Mate 9",
      "Mate 9 Pro",
      "Mate 10 Lite",
      "Mate 10",
      "Mate 10 Pro",
      "Mate 20 Lite",
      "Mate 20",
      "Mate 20 Pro",
      "Mate 30 Lite",
      "Mate 30",
      "Mate 30 Pro",
    ],
    "P Series":[
      "P8 Lite",
      "P8",
      "P9 Lite",
      "P9",
      "P10",
      "P9 Plus",
      "P10 Lite",
      "P10 Plus",
      "P20 Lite",
      "P20",
      "P20 Pro",
      "P30 Lite",
      "P30",
      "P30 Pro",
      "P40 / P40 Lite",
      "P40 Pro",
    ], 
    "Y Series":[
      "Y3 II",
      "Y5 / Y5 II",
      "Y9 Prime 2019",
"Y9 2019",
"Y7 Prime / Y7 Pro",
"Y7 / Y7S",
"Y6 2018",
"Y6 Elite",
"Y625",
"Y6 (7A) / Y6 II",
      
    ],
    "Nova Series":[
      "Nova 5 Pro",
"Nova 5T",
"Nova 2i",
"Nova 2 Lite",
"Nova 3i",
"Nova 3E",
"Nova 3",
"Nova 2",
    ], 
  "Honor Series":[
      "Honor 20",
"Honor V10",
"Honor 10",
"Honor 9 / 9 Lite",
"Honor 8 / 8X",
"Honor 7 / 7A / 7X",
"Honor 6 Plus",
"Honor 6 GR5",
"Honor 6X",
    ], 
  "G Series":[
    "Nexus 6P",
"Huawei V3",
"Huawei G9",
"Huawei G8",
"Huawei G7",
"Huawei G730",
  ],

  "A Series": [
    "A98 5G", "A96 5G", "A96 4G", "A95", "A94", "A93 5G", "A92", "A91", "A83", 
    "A80", "A79 2023", "A79 2016", "A78 5G", "A78 4G", "A77 5G", "A77 4G", 
    "A77 2017", "A76", "A74 5G", "A74 4G", "A73", "A72 5G", "A72", "A59", 
    "A58X", "A58", "A57", "A56", "A54 5G", "A54 4G", "A54S", "A53", "A53S", 
    "A52", "A38", "A36", "A35", "A18", "A17K", "A17", "A16S", "A15S", "A15", 
    "A9 2020", "A8", "A5", "AX5S", "A7X", "A5 2020", "AX5", "A3S", "A1 Pro", 
    "A1X", "AX7"
  ],
  "Reno Series": [
    "Reno 12 Pro 5G", "Reno 12 5G", "Reno 11 F 5G", "Reno 10 Pro", "Reno 10 5G", 
    "Reno 10X Zoom", "Reno 9 Pro Plus", "Reno 9 Pro", "Reno 9", "Reno 8 Pro Plus", 
    "Reno 8 Pro", "Reno 8 Lite 5G", "Reno 8 5G", "Reno 7 5G", "Reno 7 4G", 
    "Reno 6", "Reno 5 Pro / 6 Pro", "Reno 4 Pro", "Reno 4 SE", "Reno 4 Z 5G", 
    "Reno 4 5G", "Reno 3 Pro", "Reno 3", "Reno 2 Z", "Reno Z", "Reno 5G"
  ],
  "R Series": [
    "R17 Pro", "R17", "R15 Pro", "R15", "R11S Plus", "R11S", "R11 Plus", 
    "R11", "R9S Plus", "R9S", "R9 Plus", "R9", "R7S", "R7 Plus", "R7"
  ],
  "Find Series": [
    "Find N2 Flip 5G", "Find X5 Pro", "Find X5", "Find X5 Lite", "Find X3 Pro", 
    "Find X3 Neo", "Find X3 Lite", "Find X2 / X2 Pro", "Find X2 Neo", 
    "Find X2 Lite", "F9 / F9 Plus", "F1", "F1S"
  ],

  "Pixel Series": [
    "Google Pixel 9 Pro XL",
    "Google Pixel 9 Pro Fold",
    "Google Pixel 9 Pro",
    "Google Pixel 9",
    "Google Pixel 8A",
    "Google Pixel 8 Pro",
    "Google Pixel 8",
    "Google Pixel 7A",
    "Google Pixel 7 Pro",
    "Google Pixel 7",
    "Google Pixel 6A",
    "Google Pixel 6 Pro",
    "Google Pixel 6",
    "Google Pixel 5A",
    "Google Pixel 5",
    "Google Pixel 4 XL",
    "Google Pixel 4A 5G",
    "Google Pixel 4A 4G",
    "Google Pixel 4",
    "Google Pixel 3A XL",
    "Google Pixel 3A",
    "Google Pixel 3 XL",
    "Google Pixel 3",
    "Google Pixel 2 XL",
    "Google Pixel 2",
    "Google Pixel XL",
    "Google Pixel",
  ],
  "Nexus Series": [
    "Google Nexus 6P",
  ],
  
  // Add more brands and models as needed
};


// Define options for the checkboxes based on the selected model
const checkboxesByModel = {
  "iPhone 13 Pro Max": [
    { title: "OEM Screen", price: 620, },
    { title: "Aftermarket Screen", price: 180 },
    { title: "Front Camera", price: 120 },
    { title: "Back Camera", price: 200 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 160 },
    { title: "Earpiece", price: 130 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iphone 8": [
    { title: "OEM Screen", price: 170, },
    { title: "Aftermarket Screen", price: 120 },
    { title: "Front Camera", price: 100 },
    { title: "Back Camera", price: 100 },
    { title: "Battery", price: 100 },
    { title: "Charging Port", price: 100 },
    { title: "Earpiece", price: 90 },
    { title: "Loud Speaker", price: 90 },
  ],
  "iPhone SE (2nd generation)": [
    { title: "OEM Screen", price: 150, },
    { title: "Aftermarket Screen", price: 120 },
    { title: "Front Camera", price: 100 },
    { title: "Back Camera", price: 110 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 80 },
    { title: "Loud Speaker", price: 80 },
  ],
 "iPhone SE (3rd generation)": [
  { title: "OEM Screen", price: 150 },
  { title: "Aftermarket Screen", price: 120 },
  { title: "Front Camera", price: 100 },
  { title: "Back Camera", price: 110 },
  { title: "Battery", price: 120 },
  { title: "Charging Port", price: 120 },
  { title: "Earpiece", price: 80 },
  { title: "Loud Speaker", price: 80 },
],
  " iPhone 8 plus": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 80 },
    { title: "Back Camera", price: 120 },
    { title: "Battery", price: 90 },
    { title: "Charging Port", price: 100 },
    { title: "Earpiece", price: 80 },
    { title: "Loud Speaker", price: 80 },
  ],
  "iPhone X": [
    { title: "OEM Screen", price: 220, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 80 },
    { title: "Back Camera", price: 120 },
    { title: "Battery", price: 90 },
    { title: "Charging Port", price: 100 },
    { title: "Earpiece", price: 90 },
    { title: "Loud Speaker", price: 90 },
  ],
  "iPhone XS": [
    { title: "OEM Screen", price: 240, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Front Camera", price: 100 },
    { title: "Back Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 90 },
    { title: "Loud Speaker", price: 90 },
  ],
  "iPhone XS Max": [
    { title: "OEM Screen", price: 280, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 130 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 100 },
  ],
  "iPhone XR": [
    { title: "OEM Screen", price: 240, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 100 },
    { title: "Back Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 100 },
  ],
  "iPhone 11": [
    { title: "OEM Screen", price: 230, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 90 },
    { title: "Back Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 90 },
    { title: "Loud Speaker", price: 90 },
  ],
  "iPhone 11 Pro": [
    { title: "OEM Screen", price: 240, },
    { title: "Aftermarket Screen", price: 140 },
    { title: "Front Camera", price: 100 },
    { title: "Back Camera", price: 150 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 110 },
  ],
  "iPhone 11 Pro Max": [
    { title: "OEM Screen", price: 270, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 150 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 150 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 12 Mini": [
    { title: "OEM Screen", price: 250, },
    { title: "Aftermarket Screen", price: 150 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 160 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],

  "iPhone 12": [
    { title: "OEM Screen", price: 280 },
    { title: "Aftermarket Screen", price: 170 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 140 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 12 Pro": [
    { title: "OEM Screen", price: 280 },
    { title: "Aftermarket Screen", price: 180 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 210 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 12 Pro Max": [
    { title: "OEM Screen", price: 550, },
    { title: "Aftermarket Screen", price: 180 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 210 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 140 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 13 Mini": [
    { title: "OEM Screen", price: 470, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 180 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 140 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 13": [
    { title: "OEM Screen", price: 300, },
    { title: "Aftermarket Screen", price: 200 },
    { title: "Front Camera", price: 110 },
    { title: "Back Camera", price: 140 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 140 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 13 Pro": [
    { title: "OEM Screen", price: 520, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Front Camera", price: 120 },
    { title: "Back Camera", price: 200 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 140 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 13 Pro Max": [
    { title: "OEM Screen", price: 620, },
    { title: "Aftermarket Screen", price: 170 },
    { title: "Front Camera", price: 130 },
    { title: "Back Camera", price: 200 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 180 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 14": [
    { title: "OEM Screen", price: 600, },
    { title: "Aftermarket Screen", price: 220 },
    { title: "Front Camera", price: 130 },
    { title: "Back Camera", price: 170 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 170 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iPhone 14 Plus": [
    { title: "OEM Screen", price: 650, },
    { title: "Aftermarket Screen", price: 220 },
    { title: "Front Camera", price: 130 },
    { title: "Back Camera", price: 170 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 170 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iPhone 14 Pro": [
    { title: "OEM Screen", price: 650, },
    { title: "Aftermarket Screen", price: 220 },
    { title: "Front Camera", price: 130 },
    { title: "Back Camera", price: 200 },
    { title: "Battery", price: 160 },
    { title: "Charging Port", price: 200 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iPhone 14 Pro Max": [
    { title: "OEM Screen", price: 750, },
    { title: "Aftermarket Screen", price: 230 },
    { title: "Front Camera", price: 150 },
    { title: "Back Camera", price: 220 },
    { title: "Battery", price: 170 },
    { title: "Charging Port", price: 200 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iPhone 15": [
    { title: "OEM Screen", price: 650, },
    { title: "Aftermarket Screen", price: 220 },
    { title: "Front Camera", price: 150 },
    { title: "Back Camera", price: 220 },
    { title: "Battery", price: 180 },
    { title: "Charging Port", price: 220 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iPhone 15 Plus": [
    { title: "OEM Screen", price: 700, },
    { title: "Aftermarket Screen", price: 200 },
    { title: "Front Camera", price: 150 },
    { title: "Back Camera", price: 180 },
    { title: "Battery", price: 180 },
    { title: "Charging Port", price: 240 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "iPhone 15 Pro": [
    { title: "OEM Screen", price: 629, },
    { title: "Aftermarket Screen", price: 159 },
    { title: "Front Camera", price: 129 },
    { title: "Back Camera", price: 199 },
    { title: "Battery", price: 139 },
    { title: "Charging Port", price: 149 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 15 Pro Max": [
    { title: "OEM Screen", price: 749, },
    { title: "Aftermarket Screen", price: 199 },
    { title: "Front Camera", price: 129 },
    { title: "Back Camera", price: 199 },
    { title: "Battery", price: 149 },
    { title: "Charging Port", price: 199 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 16E": [
    { title: "OEM Screen", price: 649, },
    { title: "Aftermarket Screen", price: 179 },
    { title: "Front Camera", price: 139 },
    { title: "Back Camera", price: 199 },
    { title: "Battery", price: 199 },
    { title: "Charging Port", price: 149 },
    { title: "Earpiece", price: 399 },
    { title: "Loud Speaker", price: 399 },
  ],
  "iPhone 16 Pro Max": [
    { title: "OEM Screen", price: 750, },
    { title: "Aftermarket Screen", price: 299 },
    { title: "Front Camera", price: 420 },
    { title: "Back Camera", price: 350 },
    { title: "Battery", price: 199 },
    { title: "Charging Port", price: 199 },
    { title: "Earpiece", price: 149 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPhone 16 Pro": [
    { title: "OEM Screen", price: 699, },
    { title: "Aftermarket Screen", price: 299 },
    { title: "Front Camera", price: 399 },
    { title: "Back Camera", price: 349 },
    { title: "Battery", price: 329 },
    { title: "Charging Port", price: 229 },
    { title: "Earpiece", price: 199 },
    { title: "Loud Speaker", price: 229 },
  ],
  "iPhone 16 Plus": [
    { title: "OEM Screen", price: 699, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Front Camera", price: 249 },
    { title: "Back Camera", price: 299 },
    { title: "Battery", price: 349 },
    { title: "Charging Port", price: 229 },
    { title: "Earpiece", price: 199 },
    { title: "Loud Speaker", price: 199 },
  ],
  /*"iPhone 16": [
    { title: "OEM Screen", price: 599, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Front Camera", price: 249 },
    { title: "Back Camera", price: 299 },
    { title: "Battery", price: 349 },
    { title: "Charging Port", price: 229 },
    { title: "Earpiece", price: 199 },
    { title: "Loud Speaker", price: 199 },
  ],*/
  "iPhone 17": [
    { title: "OEM Screen", price: 899, },
    { title: "Aftermarket Screen", price: 849 },
    { title: "Front Camera", price: 399 },
    { title: "Back Camera", price: 499 },
    { title: "Battery", price: 399 },
    { title: "Charging Port", price: 299 },
    { title: "Earpiece", price: 149 },
    { title: "Loud Speaker", price: 249 },
  ],
  "iPhone 17 Air": [
    { title: "OEM Screen", price: 799, },
    { title: "Aftermarket Screen", price: 799 },
    { title: "Front Camera", price: 799 },
    { title: "Back Camera", price: 799 },
    { title: "Battery", price: 799 },
    { title: "Charging Port", price: 599 },
    { title: "Earpiece", price: 179 },
    { title: "Loud Speaker", price: 499 },
  ],
  "iPhone 17 Pro": [
    { title: "OEM Screen", price: 849, },
    { title: "Aftermarket Screen", price: 799 },
    { title: "Front Camera", price: 399 },
    { title: "Back Camera", price: 599 },
    { title: "Battery", price: 399 },
    { title: "Charging Port", price: 499 },
    { title: "Earpiece", price: 299 },
    { title: "Loud Speaker", price: 299 },
  ],
  "iPhone 17 Pro Max": [
    { title: "OEM Screen", price: 949, },
    { title: "Aftermarket Screen", price: 899 },
    { title: "Front Camera", price: 599 },
    { title: "Back Camera", price: 799 },
    { title: "Battery", price: 399 },
    { title: "Charging Port", price: 399 },
    { title: "Earpiece", price: 399 },
    { title: "Loud Speaker", price: 399 },
  ],
  "S25 FE":[
    { title: "OEM Screen", price: 499, },
    { title: "Aftermarket Screen", price: 389 },
    { title: "OEM Back Glass", price: 219 },
    { title: "Aftermarket Back Glass", price: 109 },
    { title: "Front Camera", price: 249 },
    { title: "Rear Camera", price: 169 },
    { title: "Battery", price: 139 },
    { title: "Charging Port", price: 149 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "S24 Ultra":[
    { title: "OEM Screen", price: 639, },
    { title: "Aftermarket Screen", price: 539 },
    { title: "OEM Back Glass", price: 199 },
    { title: "Aftermarket Back Glass", price: 129 },
    { title: "Front Camera", price: 149 },
    { title: "Rear Camera", price: 299 },
    { title: "Battery", price: 149 },
    { title: "Charging Port", price: 149 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "S24 Plus":[
     { title: "OEM Screen", price: 429, },
    { title: "Aftermarket Screen", price: 379 },
    { title: "OEM Back Glass", price: 179 },
    { title: "Aftermarket Back Glass", price: 129 },
    { title: "Front Camera", price: 149 },
    { title: "Rear Camera", price: 199 },
    { title: "Battery", price: 149 },
    { title: "Charging Port", price: 149 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 119 },
  ],
  "S24":[
     { title: "OEM Screen", price: 399, },
    { title: "Aftermarket Screen", price: 349 },
    { title: "OEM Back Glass", price: 149 },
    { title: "Aftermarket Back Glass", price: 99 },
    { title: "Front Camera", price: 149 },
    { title: "Rear Camera", price: 199 },
    { title: "Battery", price: 149 },
    { title: "Charging Port", price: 149 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 119 },
  ],
  "S23 Ultra": [
    { title: "OEM Screen", price: 470.00, },
    { title: "Aftermarket Screen", price: 419 },
    { title: "OEM Back Glass", price: 150 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 130 },
    { title: "Rear Camera", price: 280 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S23 Plus": [
    { title: "OEM Screen", price: 360.00, },
    { title: "Aftermarket Screen", price: 300 },
    { title: "OEM Back Glass", price: 149 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 130 },
    { title: "Rear Camera", price: 200 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 115 },
  ],
  "S23": [
    { title: "OEM Screen", price: 330.00, },
    { title: "Aftermarket Screen", price: 300 },
    { title: "OEM Back Glass", price: 154 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 130 },
    { title: "Rear Camera", price: 200 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 109 },
    { title: "Loud Speaker", price: 115 },
  ],
  "s23 FE": [
    { title: "OEM Screen", price: 270.00, },
  ],
  "S22 Ultra": [
    { title: "OEM Screen", price: 490.00, },
    { title: "Aftermarket Screen", price: 430 },
    { title: "OEM Back Glass", price: 190 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 590 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 110 },
  ],
  "S22 Plus": [
    { title: "OEM Screen", price: 330.00, },
    { title: "Aftermarket Screen", price: 300 },
    { title: "OEM Back Glass", price: 150 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 270 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 110 },
  ],

  "S21 Ultra": [
    { title: "OEM Screen", price: 450.00, },
    { title: "Aftermarket Screen", price: 370 },
    { title: "Aftermarket Back Glass", price: 130 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 290 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "S21 Plus": [
    { title: "OEM Screen", price: 320.00, },
    { title: "Aftermarket Screen", price: 270 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 250 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 115 },
  ],
  "S21": [
    { title: "OEM Screen", price: 320.00, },
    { title: "Aftermarket Screen", price: 270 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 250 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 115 },
  ],
  "S21 FE": [
    { title: "OEM Screen", price: 290.00, },
    { title: "Aftermarket Screen", price: 255 },
    { title: "Aftermarket Back Glass", price: 115 },
    { title: "Front Camera", price: 137 },
    { title: "Rear Camera", price: 210 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S20 Ultra": [
    { title: "OEM Screen", price: 400.00, },
    { title: "Aftermarket Screen", price: 337 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 360 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "S20 Plus": [
    { title: "OEM Screen", price: 380.00, },
    { title: "Aftermarket Screen", price: 342 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 250 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "S20": [
    { title: "OEM Screen", price: 365.00, },
    { title: "Aftermarket Screen", price: 310 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 210 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S20 FE": [
    { title: "OEM Screen", price: 250, },
    { title: "Aftermarket Screen", price: 220 },
    { title: "Aftermarket Back Glass", price: 115 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 250 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "S10 5G": [
    { title: "OEM Screen", price: 350, },
    { title: "Aftermarket Screen", price: 320 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 130 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 110 },
  ],
  "S10 Plus": [
    { title: "OEM Screen", price: 360, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S10": [
    { title: "OEM Screen", price: 360, },
    { title: "Aftermarket Screen", price: 310 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S10e": [
    { title: "OEM Screen", price: 320, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S9 Plus": [
    { title: "OEM Screen", price: 310, },
    { title: "Aftermarket Screen", price: 270 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S9": [
    { title: "OEM Screen", price: 280, },
    { title: "Aftermarket Screen", price: 230 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 115 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S8 Plus": [
    { title: "OEM Screen", price: 210, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 115 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "S8": [
    { title: "OEM Screen", price: 300, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 115 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "Note 20 Ultra": [
    { title: "OEM Screen", price: 460, },
    { title: "Aftermarket Screen", price: 400 },
    { title: "OEM Back Glass", price: 230 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 370 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "Note 20": [
    { title: "OEM Screen", price: 360, },
    { title: "Aftermarket Screen", price: 315 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 280 },
    { title: "Battery", price: 135 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 120 },
  ],
  "Note 10 Plus 4G/5G": [
    { title: "OEM Screen", price: 470, },
    { title: "Aftermarket Screen", price: 420 },
    { title: "Aftermarket Back Glass", price: 115 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 170 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "Note 10": [
    { title: "OEM Screen", price: 380, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 130 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "Note 9": [
    { title: "OEM Screen", price: 390, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "Note 8": [
    { title: "OEM Screen", price: 370, },
    { title: "Aftermarket Screen", price: 330 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "Note 5": [
    { title: "OEM Screen", price: 250, },
    { title: "Aftermarket Back Glass", price: 105 },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 115 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A04s A047": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A90 5G": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 115 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A8 A530": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
  ],
  "A73 5G A736": [
    { title: "OEM Screen", price: 260, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A72 A725": [
    { title: "OEM Screen", price: 210, },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A71 5G A716": [
    { title: "Battery", price: 140 },
  ],
  "A71 A715": [
    { title: "OEM Screen", price: 230, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 115 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A70 2019 A705": [
    { title: "OEM Screen", price: 240, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A54 [5G] A546": [
    { title: "OEM Screen", price: 230, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A53 [5G] A536": [
    { title: "OEM Screen", price: 300, },
    { title: "Aftermarket Screen", price: 270 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
  ],
  "A52s A528": [
    { title: "OEM Screen", price: 230, },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
  ],
  "A52 A525 A526": [
    { title: "OEM Screen", price: 230, },
    { title: "Aftermarket Screen", price: 200 },
    { title: "Front Camera", price: 120 },
    { title: "Rear Camera", price: 130 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 130 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A51 5G A516": [
    { title: "Charging Port", price: 140 },
  ],
  "A51 A515": [
    { title: "OEM Screen", price: 220, },
    { title: "Aftermarket Screen", price: 180 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 130 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A50S A507": [
    { title: "OEM Screen", price: 170, },
  ],
  "A50 A505": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Back Glass", price: 99 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A42 A426": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Back Glass", price: 115 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
  ],
  "A40 2019 A405": [
    { title: "OEM Back Glass", price: 150 },
  ],
  "A35 5G A356":[
    { title: "OEM Screen", price: 269, },
    { title: "Aftermarket Screen", price: 229 },
    { title: "Battery", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 110 },
    
  ],
  "A34 [5G] A346": [
    { title: "OEM Screen", price: 240, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A33 [5G] A336": [
    { title: "OEM Screen", price: 250, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A32 A325 A326": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 150 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A31 A315": [
    { title: "OEM Screen", price: 210, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "A30s A307": [
    { title: "OEM Screen", price: 220, },
    { title: "Charging Port", price: 115 },
  ],
  "A30 2019 A305": [
    { title: "OEM Screen", price: 210, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A24 4G A245": [
    { title: "OEM Screen", price: 210, },
  ],
  "A23 5G A236": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 140 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A23 A235": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A22 5G A226": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Screen", price: 150 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 110 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A22 4G A225": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 115 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A21s A217": [
    { title: "OEM Screen", price: 200, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 115 },
    { title: "Rear Camera", price: 130 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 115 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A20s A207": [
    { title: "OEM Screen", price: 200, },
  ],
  "A20 A205": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 110 },
    { title: "Loud Speaker", price: 115 },
  ],
  "A14 [5G] A146": [
    { title: "OEM Screen", price: 200, },
    { title: "Aftermarket Screen", price: 140 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A14 [4G] A145": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 140 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A13s A137": [
    { title: "OEM Screen", price: 190, },
    { title: "Charging Port", price: 115 },
  ],
  "A13 5G A136": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Screen", price: 140 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
  ],
  "A13 A135": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 170 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 115 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A12 Nacho A127": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 150 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
  ],
  "A12 A125": [
    { title: "OEM Screen", price: 170, },
    { title: "Aftermarket Screen", price: 150 },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 110 },
  ],
  "A11 A115": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Aftermarket Back Glass", price: 130 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A10 A105": [
    { title: "Aftermarket Screen", price: 150 },
  ],
  "A04s A047": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A810 A8 2016": [
    { title: "Charging Port", price: 130 },
  ],
  "A750 A7 2018": [
    { title: "OEM Screen", price: 190, },
    { title: "Front Camera", price: 110 },
  ],
  "A730 A8 Plus 2018": [
    { title: "OEM Screen", price: 150, },
  ],
  "A720 A7 2017": [
    { title: "OEM Screen", price: 210, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
  ],
  "A710 A7 2016": [

  ],
  "A700 A7 2015": [
    { title: "OEM Screen", price: 130, },
    { title: "Charging Port", price: 130 },
  ],
  "A605 A6 Plus 2018": [
    { title: "Charging Port", price: 120 },
  ],
  "A600 A6 Plus 2018": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
  ],
  "A530 A8 2018": [
    { title: "OEM Screen", price: 190, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
  ],
  "A520 A5 2017": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
  ],
  "A510 A5 2016": [
    { title: "OEM Screen", price: 230, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 105 },
    { title: "Charging Port", price: 110 },
    { title: "Loud Speaker", price: 105 },
  ],
  "A500 A5 2015": [
    { title: "OEM Screen", price: 230, },
    { title: "Charging Port", price: 110 },
  ],
  "A320 A3 2017": [
    { title: "OEM Screen", price: 230, },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 110 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
  ],
  "A310 A3 2016": [
    { title: "OEM Screen", price: 220, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 110 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
  ],
  "A300 A3 2015": [
    { title: "Rear Camera", price: 110 },
  ],
  "J8 2018 J810": [
    { title: "OEM Screen", price: 190, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
  ],
  "J7 Prime 2016 G610": [
    { title: "OEM Screen", price: 150, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "J7 Pro 2017 J730": [
    { title: "OEM Screen", price: 170, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
  ],
  "J7 Duo 2016 J710": [
  ],
  "J7 2015 J700": [
    { title: "OEM Screen", price: 220, },
  ],
  "J5 Prime 2016 G570": [
    { title: "OEM Screen", price: 170, },
    { title: "Aftermarket Back Glass", price: 110 },
    { title: "Front Camera", price: 105 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
    { title: "Loud Speaker", price: 105 },
  ],
  "J5 Pro 2017 J530": [
    { title: "OEM Screen", price: 180, },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Earpiece", price: 105 },
  ],
  "J5 2016 J510": [
    { title: "OEM Screen", price: 250, },
  ],
  "J5 Prime 2016 G570": [
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
  ],
  "J3 Pro 2017 J330": [
    { title: "OEM Screen", price: 200, },
  ],
  "J3 2016 J300 J320": [
    { title: "OEM Screen", price: 220, },
  ],
  "J2 Pro 2018 J250": [
    { title: "OEM Screen", price: 170, },
    { title: "Rear Camera", price: 115 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
    { title: "Earpiece", price: 105 },
  ],
  "J1 2016 J120": [
    { title: "OEM Screen", price: 190, },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
  ],
  "J1 Ace 2016 J110": [
    { title: "OEM Screen", price: 180, },
  ],
  "J1 Mini J105 J106": [
    { title: "OEM Screen", price: 130, },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 110 },
  ],
  "J100": [
    { title: "OEM Screen", price: 140, },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 105 },
    { title: "Earpiece", price: 105 },
  ],
  "Z Fold 6": [
    { title: "OEM Screen", price: 899, },
  ],
  "Z Fold 5": [
    { title: "OEM Screen", price: 850, },
    { title: "OEM Back Glass", price: 150 },
    { title: "Aftermarket Back Glass", price: 130 },
  ],
  "Z Fold 4": [
    { title: "OEM Screen", price: 900, },
    { title: "Aftermarket Screen", price: 640 },
    { title: "Aftermarket Back Glass", price: 130 },
    { title: "Front Camera", price: 140 },
    { title: "Rear Camera", price: 170 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 150 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "Z Fold 3": [
    { title: "OEM Screen", price: 860, },
    { title: "OEM Back Glass", price: 150 },
    { title: "Aftermarket Back Glass", price: 130 },
    { title: "Front Camera", price: 130 },
    { title: "Rear Camera", price: 160 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 140 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 130 },
  ],
  "Z Fold 2": [
    { title: "OEM Screen", price: 820, },
    { title: "Aftermarket Screen", price: 585 },
    { title: "Aftermarket Back Glass", price: 130 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 130 },
  ],
  "Z Fold ": [
    { title: "Aftermarket Screen", price: 585 },
  ],
  "Z Flip 5": [
    { title: "OEM Screen", price: 550, },
    { title: "OEM Back Glass", price: 150 },
    { title: "Aftermarket Back Glass", price: 130 },
  ],
  "Z Flip 4": [
    { title: "OEM Screen", price: 550, },
    { title: "Aftermarket Screen", price: 499 },
    { title: "Aftermarket Back Glass", price: 130 },
    { title: "Front Camera", price: 140 },
    { title: "Rear Camera", price: 200 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 120 },
  ],
  "Z Flip 3": [
    { title: "OEM Screen", price: 550, },
    { title: "Aftermarket Screen", price: 480 },
    { title: "OEM Back Glass", price: 150 },
    { title: "Aftermarket Back Glass", price: 120 },
    { title: "Front Camera", price: 120 },
    { title: "Rear Camera", price: 140 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 130 },
    { title: "Earpiece", price: 120 },
    { title: "Loud Speaker", price: 120 },
  ],
  "Z Flip 5G": [
    { title: "OEM Screen", price: 750, },
  ],
   "Z Flip 6": [
    { title: "OEM Screen", price: 549, },
  ],
  "Z Flip 4G": [
    { title: "OEM Screen", price: 750, },
    { title: "Aftermarket Back Glass", price: 120 },
  ],

  // ......................... watches........................... 
  "Apple Watch 8 41MM": [
    { title: "Aftermarket Screen", price: 350 },
    { title: "Battery", price: 150 },
  ],
  "Apple Watch 8 45MM": [
    { title: "Aftermarket Screen", price: 330 },
    { title: "Battery", price: 150 },
  ],
  "Apple Watch SE2 40MM": [
    { title: "Aftermarket Screen", price: 250 },
    { title: "Battery", price: 140 },
  ],
  "Apple Watch SE2 44MM": [
    { title: "Aftermarket Screen", price: 290 },
    { title: "Battery", price: 140 },
  ],
  "Apple Watch 7 41MM": [
    { title: "Aftermarket Screen", price: 250 },
    { title: "Battery", price: 150 },
  ],
  "Apple Watch 7 44MM": [
    { title: "Aftermarket Screen", price: 270 },
    { title: "Battery", price: 150 },
  ],
  "Apple Watch SE 40MM": [
    { title: "Aftermarket Screen", price: 240 },
    { title: "Battery", price: 120 },
  ],
  "Apple Watch SE 44MM": [
    { title: "Aftermarket Screen", price: 280 },
    { title: "Battery", price: 120 },
  ],
  "Apple Watch 6 40MM": [
    { title: "Aftermarket Screen", price: 210 },
    { title: "Battery", price: 130 },
  ],
  "Apple Watch 6 44MM": [
    { title: "Aftermarket Screen", price: 260 },
    { title: "Battery", price: 130 },
  ],
  "Apple Watch 5 40MM": [
    { title: "Aftermarket Screen", price: 250 },
    { title: "Battery", price: 120 },
  ],
  "Apple Watch 5 44MM": [
    { title: "Aftermarket Screen", price: 280 },
    { title: "Battery", price: 130 },
  ],
  "Apple Watch 4 40mm": [
    { title: "Aftermarket Screen", price: 230 },
    { title: "Battery", price: 130 },
  ],
  "Apple Watch 4 44mm": [
    { title: "Aftermarket Screen", price: 250 },
    { title: "Battery", price: 130 },
  ],
  "Apple Watch 3 38mm": [
    { title: "Aftermarket Screen", price: 180 },
    { title: "Battery", price: 120 },
  ],

  "Apple Watch 3 42mm": [
    { title: "Aftermarket Screen", price: 210 },
    { title: "Battery", price: 120 },
  ],

  "Apple Watch 2 38mm": [
    { title: "Aftermarket Screen", price: 180 },
    { title: "Battery", price: 115 },
  ],

  "Apple Watch 2 42mm": [
    { title: "Aftermarket Screen", price: 210 },
    { title: "Battery", price: 115 },
  ],

  "Apple Watch 1 38mm": [
    { title: "Aftermarket Screen", price: 170 },
  ],

  "Apple Watch 1 42mm": [
    { title: "Aftermarket Screen", price: 170 },
  ],

  // ......................... galaxy tablet........................... */
  "Note Pro 12.2": [

    { title: "Aftermarket Screen", price: 300 },

  ],
  "Note 10.1": [

    { title: "Aftermarket Screen", price: 200 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],

  "Note 8.0": [
    { title: "Aftermarket Screen", price: 180 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },

  ],
  "Tab Active 4 Pro":[
     { title: "OEM Screen", price: 199 },
  ],
  "Tab Active Pro 10.1": [
    { title: "Aftermarket Screen", price: 180 },
    { title: "Charging Port", price: 130 },

  ],
  "Tab Active 3": [
    { title: "Aftermarket Screen", price: 180 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 140 },

  ],

  "Tab Active 2": [
    { title: "Aftermarket Screen", price: 170 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },

  ],
  "Tab Active": [
    { title: "Aftermarket Screen", price: 180 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },

  ],
  "Tab Pro": [
    { title: "Charging Port", price: 120 },

  ],
  "Tab S9 / S9 Ultra / S9 FE": [
    { title: "OEM Screen", price: 610, },
    { title: "Aftermarket Screen", price: 499 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab S8 Plus X800 X808": [
    { title: "OEM Screen", price: 480, },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab S8 (X700 X706)": [
    { title: "OEM Screen", price: 330, },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab S8 Ultra": [
    { title: "OEM Screen", price: 620, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab S7 FE": [
    { title: "OEM Screen", price: 220, },
  ],
  "Tab S7 / S7 Plus": [
    { title: "OEM Screen", price: 470, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 140 },
  ],
  "Tab S6 / S6 Lite": [
    { title: "OEM Screen", price: 370, },
    { title: "Aftermarket Screen", price: 499 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 140 },
  ],
  "Tab S5E": [
    { title: "OEM Screen", price: 380, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab S4": [
    { title: "OEM Screen", price: 400, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 140 },
  ],
  "Tab S3": [
    { title: "OEM Screen", price: 370, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab S2": [
    { title: "OEM Screen", price: 250, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab S": [
    { title: "OEM Screen", price: 250, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab 4": [
    { title: "OEM Screen", price: 160, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab 3": [
    { title: "OEM Screen", price: 250, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "Tab 2": [
    { title: "OEM Screen", price: 160, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab 1": [
    { title: "OEM Screen", price: 170, },
  ],
   "Tab A9 Plus": [
    { title: "Aftermarket Screen", price: 199, },
    { title: "Charging Port", price: 120 },
  ],
  "Tab A8 10.5 (X200 X205)": [
    { title: "OEM Screen", price: 180, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab A7 Lite T225": [
    { title: "OEM Screen", price: 200, },
    { title: "Aftermarket Screen", price: 160 },
  ],
  "Tab A7 Lite T220": [
    { title: "OEM Screen", price: 200, },
    { title: "Aftermarket Screen", price: 160 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab A7 10.4": [
    { title: "Aftermarket Screen", price: 170 },
    { title: "Battery", price: 139 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab A 10.5": [
    { title: "Aftermarket Screen", price: 170 },
    { title: "Battery", price: 139 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab A 10.1": [
    { title: "OEM Screen", price: 200, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab A 9.7": [
    { title: "OEM Screen", price: 200, },
    { title: "Aftermarket Screen", price: 170 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "Tab A 8.0 (SM-X200 SM-X205)": [
    { title: "Aftermarket Screen", price: 160 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],

  "Tab A 7.0": [
    { title: "OEM Screen", price: 170, },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  //......................... APPLE IPAD...........................

  "iPad 10 (2022)": [

    { title: "Aftermarket Screen", price: 170 },
    { title: "Battery", price: 130 },
  ],
  "iPad 9 (2021)": [

    { title: "Aftermarket Screen", price: 150 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 7 (2019) / 8 (2020)": [
    { title: "OEM Screen", price: 140, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 6 (2018)": [
    { title: "OEM Screen", price: 140, },
    { title: "Aftermarket Screen", price: 130 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 5 (2017)": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 4": [
    { title: "Aftermarket Screen", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 3": [
    { title: "Aftermarket Screen", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 2": [
    { title: "Aftermarket Screen", price: 120 },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad 1": [
    { title: "Charging Port", price: 120 },
    { title: "Loud Speaker", price: 120 },
  ],
  "iPad Air 5": [
    { title: "OEM Screen", price: 330, },
    { title: "Battery", price: 160 },
    { title: "Charging Port", price: 140 },
  ],

  "iPad Air 4": [
    { title: "OEM Screen", price: 300, },
    { title: "Rear Camera", price: 160 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Air 3": [
    { title: "OEM Screen", price: 280, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Air 2": [
    { title: "OEM Screen", price: 250, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 110 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "iPad Air 1": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 120 },
    { title: "Charging Port", price: 120 },
  ],

  "iPad Pro 12.9 5th": [
    { title: "OEM Screen", price: 550, },
    { title: "Battery", price: 160 },
    { title: "Charging Port", price: 150 },
  ],
  "iPad Pro 12.9 4th": [
    { title: "OEM Screen", price: 450, },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Pro 12.9 3rd": [
    { title: "OEM Screen", price: 450, },
    { title: "Rear Camera", price: 150 },
    { title: "Battery", price: 190 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Pro 12.9 2nd": [
    { title: "OEM Screen", price: 570, },
    { title: "Front Camera", price: 120 },
    { title: "Battery", price: 160 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Pro 12.9 1st": [
    { title: "OEM Screen", price: 390, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 150 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Pro 11 3rd / 4th": [
    { title: "OEM Screen", price: 580, },
    { title: "Battery", price: 180 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Pro 11 1st / 2nd": [
    { title: "OEM Screen", price: 380, },
    { title: "Rear Camera", price: 160 },
    { title: "Battery", price: 170 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Pro 10.5": [
    { title: "OEM Screen", price: 320, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 150 },
    { title: "Battery", price: 140 },
    { title: "Charging Port", price: 120 },
  ],
  "iPad Pro 9.7": [
    { title: "OEM Screen", price: 150, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
  ],
  "iPad Mini 6": [
    { title: "OEM Screen", price: 570, },
    { title: "Charging Port", price: 160 },
  ],
  "iPad Mini 5": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
  ],
  "iPad Mini 4": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },

  ],
  "iPad Mini 3": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 130 },
    { title: "Loud Speaker", price: 110 },
  ],
  "iPad Mini 2": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Loud Speaker", price: 110 },
  ],
  "iPad Mini 1": [
    { title: "OEM Screen", price: 130, },
    { title: "Front Camera", price: 110 },
    { title: "Rear Camera", price: 120 },
    { title: "Battery", price: 130 },
    { title: "Charging Port", price: 120 },
    { title: "Loud Speaker", price: 110 },
  ],
  //Realme 
  "Realme 2": [{"title": "Aftermarket Screen", "price": 149.0}], 
  "Realme 2 Pro": [{"title": "Aftermarket Screen", "price": 149.0}],
  "Realme 3": [{"title": "Aftermarket Screen", "price": 149.0}], 
  "Realme 3i": [{"title": "Aftermarket Screen", 'price': 149.0}],
  "Realme 6": [{"title": "Aftermarket Screen", "price": 150.0}], 
  "Realme 7": [{"title": "Aftermarket Screen", "price": 150.0}], 
  "Realme 7 5G": [{"title": "Aftermarket Screen", "price": 150.0}], 
  "Realme C1": [{"title": "Aftermarket Screen", "price": 149.0}],
  "Realme C11": [{"title": "Aftermarket Screen", "price": 149.0}], 
  "Realme C12": [{"title": "Aftermarket Screen", "price": 149.0}],
  "Realme C15": [{"title": "Aftermarket Screen", "price": 149.0}], 
  "Realme C2": [{"title": "Aftermarket Screen", "price": 149.0}], 
  "Realme C21": [{'title': 'Aftermarket Screen', 'price': 149.0}],
  "Realme C3": [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  "Realme C55": [{'title': 'Aftermarket Screen', 'price': 149.0}],
  
// Huawei
  'Honor 6 GR5': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}], 
'Honor 6 Plus': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
'Honor 7 / 7A / 7X': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
'Honor 8 / 8X': [{'title': 'Aftermarket Screen', 'price': 149.0}],
'Honor 9 / 9 Lite': [{'title': 'Aftermarket Back Glass', 'price': 110.0}], 
'Huawei G7': [{'title': 'Aftermarket Screen', 'price': 130.0}], 
'Huawei G8': [{'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}], 
'Huawei G9': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
'Mate 10': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Charging Port', 'price': 110.0}], 
'Mate 10 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
'Mate 10 Pro': [{'title': 'Aftermarket Screen', 'price': 269.0}, {'title': 'Battery', 'price': 110.0}, {'title': 'Charging Port', 'price': 110.0}], 
'Mate 20': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}], 
'Mate 20 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
'Mate 20 Pro': [{'title': 'Aftermarket Screen', 'price': 299.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Charging Port', 'price': 120.0}],
'Mate 30 Lite': [{'title': 'Aftermarket Screen', 'price': 179.0}], 
'Mate 30 Pro': [{'title': 'OEM Screen', 'price': 499.0}, {'title': 'Aftermarket Screen', 'price': 479.0}, {'title': 'Charging Port', 'price': 120.0}], 
'Mate 7': [{'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
  'Mate 8': [{'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
  'Mate 9': [{'title': 'Aftermarket Screen', 'price': 179.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}],
'Mate 9 Pro': [{'title': 'Aftermarket Screen', 'price': 310.0}], 
'Nexus 6P': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
  'Nova 2': [{'title': 'Aftermarket Screen', 'price': 149.0}],
  'Nova 2 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}],
  'Nova 2i': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
  'Nova 3': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 130.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'Nova 3E': [{'title': 'Aftermarket Screen', 'price': 130.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}], 'Nova 3i': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 130.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'Nova 5 Pro': [{'title': 'Aftermarket Screen', 'price': 199.0}], 
  'Nova 5T': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'P10': [{'title': 'Aftermarket Screen', 'price': 160.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'P10 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}],
  'P10 Plus': [{'title': 'Aftermarket Screen', 'price': 160.0}, {'title': 'Rear Cameras', 'price': 120.0}], 
  'P20': [{'title': 'Aftermarket Screen', 'price': 160.0}], 
  'P20 Lite': [{'title': 'Aftermarket Screen', 'price': 130.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}], 
  'P20 Pro': [{'title': 'Aftermarket Screen', 'price': 279.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'P30': [{'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 140.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'P30 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'P30 Pro': [{'title': 'Aftermarket Screen', 'price': 279.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 110.0}], 
  'P40 / P40 Lite': [{'title': 'Aftermarket Screen', 'price': 150.0}, {'title': 'Battery', 'price': 120.0}], 
  'P40 Pro': [{'title': 'Aftermarket Screen', 'price': 499.0}],
  'P8': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 105.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
  'P8 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'P9': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
  'P9 Lite': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'P9 Plus': [{'title': 'Aftermarket Screen', 'price': 149.0}],
  'Y5 / Y5 II': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'Y6 (7A) / Y6 II': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'Y6 2018': [{'title': 'Aftermarket Screen', 'price': 149.0}],
  'Y625': [{'title': 'Aftermarket Screen', 'price': 120.0}], 
  'Y7 / Y7S': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Y7 Prime / Y7 Pro': [{'title': 'Front Camera', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Y9 2019': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'Y9 Prime 2019': [{'title': 'Aftermarket Screen', 'price': 149.0}],
  
// Oppo
  'A1 Pro': [{'title': 'Aftermarket Screen', 'price': 199.0}],
 'A15': [{'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
 'A15S': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
 'A16S': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 115.0}, {'title': 'Rear Cameras', 'price': 115.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'A17': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A17K': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A18': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}], 
  'A1X': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A35': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A36': [{'title': 'Aftermarket Screen', 'price': 149.0}], 'A38': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}],
  'A3S': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 129.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 105.0}],
  'A5': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Rear Cameras', 'price': 129.0}],
  'A5 2020': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
  'A52': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 99.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'A53': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 99.0}, {'title': 'Battery', 'price': 110.0}, {'title': 'Charging Port', 'price': 110.0}],
  'A53S': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 99.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
  'A54 4G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'A54 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'A54S': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A56': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'A57': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 99.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Charging Port', 'price': 99.0}, {'title': 'Earpiece', 'price': 99.0}, {'title': 'Loud Speaker', 'price': 99.0}],
  'A58': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}],
  'A58X': [{'title': 'Aftermarket Screen', 'price': 149.0}],
  'A72': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 'A72 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A73': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 105.0}],
  'A74 4G': [{'title': 'OEM Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}], 
  'A74 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 99.0}, {'title': 'Loud Speaker', 'price': 99.0}],
  'A76': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 120.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 139.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'A77 2017': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A77 4G': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
  'A77 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'A78 4G': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Charging Port', 'price': 110.0}],
  'A78 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 129.0}, {'title': 'Front Camera', 'price': 120.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
'A79 2016': [{'title': 'Aftermarket Screen', 'price': 149.0}],
'A79 2023': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}],
'A7X': [{'title': 'Aftermarket Screen', 'price': 149.0}],
'A8': [{'title': 'Aftermarket Screen', 'price': 149.0}],
'A83': [{'title': 'Aftermarket Screen', 'price': 149.0}],
'A9 2020': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
'A91': [{'title': 'Aftermarket Screen', 'price': 210.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
'A92': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}],
'A93 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
'A94': [{'title': 'Aftermarket Screen', 'price': 149.0}], 
'A95': [{'title': 'Aftermarket Screen', 'price': 199.0}], 
'A96 4G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}], 
'A96 5G': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}], 
'A98 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 139.0}, {'title': 'Rear Cameras', 'price': 139.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
'AX5': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Rear Cameras', 'price': 129.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
'AX5S': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'AX7': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
'F1S': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
'F9 / F9 Plus': [{'title': 'Aftermarket Screen', 'price': 149.0}],
'Find N2 Flip 5G': [{'title': 'Aftermarket Screen', 'price': 569.0}, {'title': 'Aftermarket Back Glass', 'price': 130.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
'Find X2 / X2 Pro': [{'title': 'OEM Screen', 'price': 399.0}, {'title': 'OEM Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
'Find X2 Lite': [{'title': 'OEM Screen', 'price': 229.0}], 
'Find X2 Neo': [{'title': 'OEM Screen', 'price': 249.0}, {'title': 'OEM Back Glass', 'price': 130.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
'Find X3 Lite': [{'title': 'OEM Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'Find X3 Neo': [{'title': 'OEM Screen', 'price': 299.0}, {'title': 'OEM Back Glass', 'price': 140.0}, {'title': 'Battery', 'price': 130.0}, {'title': 'Charging Port', 'price': 120.0}], 
'Find X3 Pro': [{'title': 'OEM Screen', 'price': 429.0}, {'title': 'Aftermarket Screen', 'price': 399.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 130.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
'Find X5': [{'title': 'OEM Screen', 'price': 549.0}, {'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'OEM Back Glass', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 130.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 130.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 'Find X5 Lite': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Battery', 'price': 130.0}], 
'Find X5 Pro': [{'title': 'Aftermarket Screen', 'price': 369.0}, {'title': 'Aftermarket Back Glass', 'price': 160.0}, {'title': 'Front Camera', 'price': 120.0}, {'title': 'Rear Cameras', 'price': 130.0}, {'title': 'Battery', 'price': 130.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
'R11': [{'title': 'Aftermarket Screen', 'price': 179.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}],
'R11 Plus': [{'title': 'Aftermarket Screen', 'price': 179.0}],
'R11S': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
'R11S Plus': [{'title': 'Aftermarket Screen', 'price': 179.0}],
'R15': [{'title': 'Aftermarket Screen', 'price': 179.0}, {'title': 'Charging Port', 'price': 110.0}], 'R15 Pro': [{'title': 'Aftermarket Screen', 'price': 179.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'R17': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Rear Cameras', 'price': 130.0}, {'title': 'Charging Port', 'price': 115.0}],
'R17 Pro': [{'title': 'Aftermarket Screen', 'price': 179.0}],
'R7': [{'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
'R7 Plus': [{'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}], 
'R7S': [{'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 105.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 105.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
'R9': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
'R9 Plus': [{'title': 'Aftermarket Screen', 'price': 169.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'R9S': [{'title': 'Aftermarket Screen', 'price': 169.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}], 
'R9S Plus': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Charging Port', 'price': 120.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'Reno 10 5G': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 115.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'Reno 10 Pro': [{'title': 'Aftermarket Back Glass', 'price': 115.0}], 'Reno 10X Zoom': [{'title': 'Aftermarket Screen', 'price': 279.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}],
'Reno 11 F 5G': [{'title': 'Aftermarket Screen', 'price': 249.0}],
'Reno 12 5G': [{'title': 'Aftermarket Screen', 'price': 215.0}, {'title': 'Aftermarket Back Glass', 'price': 129.0}], 
'Reno 12 Pro 5G': [{'title': 'Aftermarket Screen', 'price': 210.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}], 
'Reno 2 Z': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}],
'Reno 3': [{'title': 'Aftermarket Screen', 'price': 210.0}, {'title': 'Aftermarket Back Glass', 'price': 139.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 'Reno 3 Pro': [{'title': 'Aftermarket Back Glass', 'price': 139.0}],
'Reno 4 5G': [{'title': 'Aftermarket Screen', 'price': 349.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
'Reno 4 Pro': [{'title': 'Aftermarket Back Glass', 'price': 139.0}], 
'Reno 4 SE': [{'title': 'Charging Port', 'price': 110.0}], 
'Reno 4 Z 5G': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
'Reno 5 Pro / 6 Pro': [{'title': 'Aftermarket Screen', 'price': 279.0}],
'Reno 5G': [{'title': 'Aftermarket Screen', 'price': 279.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Charging Port', 'price': 110.0}],
'Reno 6': [{'title': 'Aftermarket Screen', 'price': 199.0}],
'Reno 7 5G': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Battery', 'price': 130.0}], 
'Reno 8 5G': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 115.0}, {'title': 'Battery', 'price': 130.0}, {'title': 'Charging Port', 'price': 120.0}], 
'Reno 8 Lite 5G': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 115.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 115.0}], 
'Reno 8 Pro': [{'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 130.0}, {'title': 'Battery', 'price': 130.0}, {'title': 'Charging Port', 'price': 115.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
'Reno 8 Pro Plus': [{'title': 'Aftermarket Screen', 'price': 179.0}], 
'Reno 9': [{'title': 'Aftermarket Screen', 'price': 199.0}],
'Reno 9 Pro': [{'title': 'Aftermarket Screen', 'price': 199.0}], 
'Reno 9 Pro Plus': [{'title': 'Aftermarket Screen', 'price': 199.0}],
'Reno Z': [{'title': 'Aftermarket Screen', 'price': 179.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}],

//Google Pixel
  
 'Google Pixel': [{'title': 'Aftermarket Screen', 'price': 149.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 105.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 110.0}], 
  'Google Pixel 2': [{'title': 'Aftermarket Screen', 'price': 159.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}], 
  'Google Pixel 2 XL': [{'title': 'Aftermarket Screen', 'price': 179.0}, {'title': 'Aftermarket Back Glass', 'price': 129.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 115.0}, {'title': 'Earpiece', 'price': 105.0}], 
  'Google Pixel 3': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Google Pixel 3 XL': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}], 
  'Google Pixel 3A': [{'title': 'Aftermarket Back Glass', 'price': 115.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}], 
  'Google Pixel 3A XL': [{'title': 'OEM Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 115.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'Google Pixel 4': [{'title': 'Aftermarket Screen', 'price': 169.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 120.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Google Pixel 4 XL': [{'title': 'Aftermarket Screen', 'price': 219.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}],
  'Google Pixel 4A 4G': [{'title': 'OEM Screen', 'price': 269.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 115.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}],
  'Google Pixel 4A 5G': [{'title': 'OEM Screen', 'price': 269.0}, {'title': 'Aftermarket Back Glass', 'price': 120.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 120.0}],
  'Google Pixel 5': [{'title': 'OEM Screen', 'price': 329.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
  'Google Pixel 5A': [{'title': 'OEM Screen', 'price': 329.0}, {'title': 'Aftermarket Screen', 'price': 269.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}],
  'Google Pixel 6': [{'title': 'OEM Screen', 'price': 349.0}, {'title': 'Aftermarket Screen', 'price': 229.0}, {'title': 'Aftermarket Back Glass', 'price': 139.0}, {'title': 'Front Camera', 'price': 149.0}, {'title': 'Rear Cameras', 'price': 279.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 139.0}],
  'Google Pixel 6 Pro': [{'title': 'OEM Screen', 'price': 499.0}, {'title': 'Aftermarket Screen', 'price': 229.0}, {'title': 'Aftermarket Back Glass', 'price': 139.0}, {'title': 'Front Camera', 'price': 129.0}, {'title': 'Rear Cameras', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 115.0}], 
  'Google Pixel 6A': [{'title': 'OEM Screen', 'price': 299.0}, {'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 139.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 110.0}], 
  'Google Pixel 7': [{'title': 'OEM Screen', 'price': 329.0}, {'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Front Camera', 'price': 129.0}, {'title': 'Rear Cameras', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 129.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Google Pixel 7 Pro': [{'title': 'OEM Screen', 'price': 499.0}, {'title': 'Aftermarket Screen', 'price': 249.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Front Camera', 'price': 129.0}, {'title': 'Rear Cameras', 'price': 149.0}, {'title': 'Battery', 'price': 120.0}, {'title': 'Charging Port', 'price': 129.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Google Pixel 7A': [{'title': 'OEM Screen', 'price': 329.0}, {'title': 'Aftermarket Screen', 'price': 279.0}, {'title': 'Aftermarket Back Glass', 'price': 129.0}, {'title': 'Battery', 'price': 139.0}, {'title': 'Charging Port', 'price': 139.0}, {'title': 'Loud Speaker', 'price': 110.0}],
  'Google Pixel 8': [{'title': 'OEM Screen', 'price': 349.0}, {'title': 'Aftermarket Screen', 'price': 299.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Front Camera', 'price': 120.0}, {'title': 'Rear Cameras', 'price': 149.0}, {'title': 'Battery', 'price': 139.0}, {'title': 'Charging Port', 'price': 139.0}],
  'Google Pixel 8 Pro': [{'title': 'OEM Screen', 'price': 499.0}, {'title': 'Aftermarket Screen', 'price': 429.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Rear Cameras', 'price': 199.0}, {'title': 'Battery', 'price': 139.0}], 'Google Pixel 8A': [{'title': 'OEM Screen', 'price': 379.0}, {'title': 'Aftermarket Screen', 'price': 329.0}, {'title': 'Aftermarket Back Glass', 'price': 129.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 159.0}, {'title': 'Battery', 'price': 139.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 110.0}], 
  'Google Pixel 9': [{'title': 'OEM Screen', 'price': 399.0}, {'title': 'Aftermarket Screen', 'price': 369.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Charging Port', 'price': 139.0}],
  'Google Pixel 9 Pro': [{'title': 'Aftermarket Screen', 'price': 399.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Charging Port', 'price': 139.0}],
  'Google Pixel 9 Pro XL': [{'title': 'OEM Screen', 'price': 519.0}, {'title': 'Aftermarket Screen', 'price': 479.0}, {'title': 'Aftermarket Back Glass', 'price': 149.0}, {'title': 'Charging Port', 'price': 139.0}, {'title': 'Earpiece', 'price': 110.0}, {'title': 'Loud Speaker', 'price': 120.0}],
   'Google Pixel 9 Pro Fold': [{'title': 'Outer Display', 'price': 220.0}, {'title': 'Inner Display', 'price': 1199.0}], 
  'Google Pixel XL': [{'title': 'Aftermarket Screen', 'price': 159.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Battery', 'price': 115.0}, {'title': 'Charging Port', 'price': 110.0}, {'title': 'Earpiece', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
  'Google Nexus 6P': [{'title': 'Aftermarket Screen', 'price': 199.0}, {'title': 'Aftermarket Back Glass', 'price': 110.0}, {'title': 'Front Camera', 'price': 110.0}, {'title': 'Rear Cameras', 'price': 110.0}, {'title': 'Charging Port', 'price': 105.0}, {'title': 'Loud Speaker', 'price': 105.0}],
  
  // Add more checkboxes for other models
};

// Function to update the second dropdown (models) options based on the selected brand
function updateCategoryDropDown() {
  const selectedBrand = brandDropdown.value;
  const categories = categoryByBrand[selectedBrand] || [];

  // Clear existing options
  categoryDropdown.innerHTML = "";
  checkboxList.innerHTML = ""; // Clear the checkbox list

  // Add new options
  categories.forEach(model => {
    const option = document.createElement("option");
    option.value = model;
    option.text = model;
    categoryDropdown.appendChild(option);
  });
  if (categories.length > 0) {
    categoryDropdown.value = categories[0];
    updateModelDropdown();
  }
}


// Function to update the second dropdown (models) options based on the selected brand
function updateModelDropdown() {
  const selectedCategory = categoryDropdown.value;
  const models = modelsByCategories[selectedCategory] || [];

  // Clear existing options
  modelDropdown.innerHTML = "";
  checkboxList.innerHTML = ""; // Clear the checkbox list

  // Add new options
  models.forEach(model => {
    const option = document.createElement("option");
    option.value = model;
    option.text = model;
    modelDropdown.appendChild(option);
  });
  if (models.length > 0) {
  modelDropdown.value = models[0];
  updateCheckboxList(); // Automatically update the checkbox list
}
}

// Function to update the checkbox list based on the selected storage
function updateCheckboxList() {

  const selectedModel = modelDropdown.value;
  const checkboxes = checkboxesByModel[selectedModel] || [];
  // Clear existing options
  checkboxList.innerHTML = "";

  // Create a new unordered list element
  const ul = document.createElement("ul");


  // Add new checkbox options
  checkboxes.forEach(option => {
    const li = document.createElement("li");
    const label = document.createElement("label");
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.name = "contact[" + option.title + "]";
    checkbox.value = option.price;
    checkbox.addEventListener("change", updateTotalPrice);

    // Create an image element for the icon
    if (checkbox.image) {
      const icon = document.createElement("img");
      icon.src = checkbox.image;
      icon.alt = checkbox.title;
      label.appendChild(icon);
    }

    label.appendChild(checkbox);
    label.appendChild(document.createTextNode(`${option.title} ($${option.price})`));
    li.appendChild(label);
    ul.appendChild(li);

    // checkboxList.appendChild(label);
  });

  // Append the new unordered list to the checkboxList div
  checkboxList.appendChild(ul);
}

// Function to update the total price based on selected checkboxes
function updateTotalPrice() {
  const selectedCheckboxes = Array.from(checkboxList.querySelectorAll("input[type='checkbox']:checked"));
  let total = 0;
  let selectedOptions = [];

  selectedCheckboxes.forEach(checkbox => {
    total += parseFloat(checkbox.value);
    selectedOptions.push(checkbox.value);
  });

  total = total + 35;

  totalPriceText.textContent = `Estimated Repair Cost: $${total.toFixed(2)}`;
  document.getElementById("totalPriceHidden").value = total.toFixed(2);

  // Update the hidden input field with selected checkbox values
  const hiddenInput = document.getElementById("selectedOptionsInput");
  hiddenInput.value = selectedOptions.join(', '); // Convert array to a comma-separated string
}


// Add event listeners to the dropdowns to trigger updates
brandDropdown.addEventListener("change", updateCategoryDropDown);
categoryDropdown.addEventListener("change", updateModelDropdown);
modelDropdown.addEventListener("change", updateCheckboxList);

// Initial updates when the page loads
updateCategoryDropDown();
updateModelDropdown();
updateCheckboxList();
updateTotalPrice();


  } catch(e) { console.error(e); }
})();
})();
